import { render, staticRenderFns } from "./AddBatch.vue?vue&type=template&id=611c03be&"
import script from "./AddBatch.vue?vue&type=script&lang=js&"
export * from "./AddBatch.vue?vue&type=script&lang=js&"
import style0 from "./AddBatch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports